import { useEffect, useRef } from 'react';

export function useEffectOnce(callback: () => void, predicate: boolean) {
    const hasBeenRunRef = useRef(false);

    useEffect(() => {
        if (predicate && !hasBeenRunRef.current) {
            callback();
            hasBeenRunRef.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [predicate]);
}
